// Module
var code = "<span ng-if=\"vm.schedule.dtstart && !vm.isRepeated()\"> {{ vm.schedule.dtstart | dateFormat }} </span> <span ng-if=\"vm.schedule.dtstart && vm.isRepeated()\"> {{ vm.schedule.dtstart | dateFormat }} - {{ vm.getEndDate() || 'No End Date' }} </span> ";
// Exports
module.exports = code;